import { html } from "lit";

interface HighlightTeaserTemplateProps {
    title: string;
    icon: string;
    ctaText: string;
    ctaLink: string;
    textWhite?: boolean;
    backgroundClass?: string;
}

export const HighlightTeaserTemplate = ({
    title,
    icon,
    ctaText,
    ctaLink,
    textWhite,
    backgroundClass = "ux-u-background-grey",
}: HighlightTeaserTemplateProps) => {
    const classNames = ["ux-iws-teaser-highlight", backgroundClass];
    if (textWhite) {
        classNames.push("ux-iws-teaser-highlight--text-white");
    }
    return html`
        <div class="${classNames.join(" ")}">
            <div class="ux-iws-teaser-highlight__icon-container">
                <ux-icon name="${icon}"></ux-icon>
            </div>
            <h3
                class="ux-iws-teaser-highlight__title ux-text-headline ux-text-headline--giant"
            >
                ${title}
            </h3>
            <div class="ux-iws-teaser-highlight__cta-container">
                <a
                    href="${ctaLink}"
                    target="_blank"
                    class="ux-button ux-button--green"
                >
                    ${ctaText}
                </a>
            </div>
        </div>
    `;
};

export const NewsroomHighlightTemplate = ({
    title,
    icon,
    ctaText,
    ctaLink,
}: HighlightTeaserTemplateProps) => {
    return html`
        <div class="ux-row ux-u-mx-zero ux-u-mt-fluid-m">
            <div class="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1">
                ${HighlightTeaserTemplate({
                    title,
                    icon,
                    ctaText,
                    ctaLink,
                    textWhite: true,
                    backgroundClass: "ux-u-background-blue-faded-horizontal",
                })}
            </div>
        </div>
    `;
};
